import { FileText, Receipt, TrendingUp, TrendingDown, Percent } from 'lucide-react';
import { fmtRon } from './reportUtils';

const Card = ({ testId, icon: Icon, label, value, tone, children }) => (
    <div data-testid={testId} className={`bg-white border rounded-xl p-4 ${tone.border}`}>
        <div className="flex items-center gap-2 mb-3">
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${tone.iconBg}`}>
                <Icon size={16} className={tone.icon} />
            </div>
            <span className="text-sm text-zinc-500">{label}</span>
        </div>
        <p data-testid={`${testId}-value`} className={`text-2xl font-bold ${tone.text}`} style={{ fontFamily: 'Outfit, sans-serif' }}>{value}</p>
        {children}
    </div>
);

const TONES = {
    violet: { border: 'border-zinc-200', iconBg: 'bg-violet-100', icon: 'text-violet-600', text: 'text-zinc-900' },
    red: { border: 'border-zinc-200', iconBg: 'bg-red-100', icon: 'text-red-600', text: 'text-red-600' },
    green: { border: 'border-emerald-200 bg-emerald-50/40', iconBg: 'bg-emerald-100', icon: 'text-emerald-600', text: 'text-emerald-700' },
    loss: { border: 'border-red-200 bg-red-50/40', iconBg: 'bg-red-100', icon: 'text-red-600', text: 'text-red-700' },
    blue: { border: 'border-zinc-200', iconBg: 'bg-blue-100', icon: 'text-blue-600', text: 'text-zinc-900' },
};

export const YearSummaryCards = ({ totals, year }) => {
    const profitOk = totals.profit >= 0;
    const tvaDue = totals.sold_tva > 0;
    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            <Card testId="card-sales" icon={FileText} label={`Vânzări facturate ${year}`} value={fmtRon(totals.sales)} tone={TONES.violet} />
            <Card testId="card-expenses" icon={Receipt} label={`Cheltuieli ${year}`} value={fmtRon(totals.expenses)} tone={TONES.red} />
            <Card testId="card-profit" icon={profitOk ? TrendingUp : TrendingDown} label="Profit real" value={`${profitOk ? '+' : ''}${fmtRon(totals.profit)}`} tone={profitOk ? TONES.green : TONES.loss}>
                <p className="text-xs text-zinc-400 mt-2">Vânzări − Cheltuieli</p>
            </Card>
            <Card testId="card-tva" icon={Percent} label="TVA colectat vs. deductibil" value={fmtRon(totals.tva_colectat)} tone={TONES.blue}>
                <p className="text-xs text-zinc-500 mt-1">Deductibil: <b data-testid="card-tva-deductibil">{fmtRon(totals.tva_deductibil)}</b></p>
                <p data-testid="card-tva-sold" className={`text-xs font-semibold mt-1 ${tvaDue ? 'text-red-600' : 'text-emerald-600'}`}>
                    {tvaDue ? 'De plată' : 'De recuperat'}: {fmtRon(Math.abs(totals.sold_tva))}
                </p>
            </Card>
        </div>
    );
};
